// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconThemePath = 'm13.737 9.244 4.013-5.355c.157-.21.242-.465.24-.724a1.236 1.236 0 0 0-.476-.968c-.485-.347-1.202-.24-1.594.265L11.94 7.8c.485.184.94.465 1.325.86.179.183.336.379.472.584Zm-1.905 3.418.016-.015c.71-.701.717-1.85.016-2.56a1.735 1.735 0 0 0-1.24-.547h-.02c-.452 0-.878.174-1.202.49-.756.776-.856 1.337-.995 2.117-.095.537-.204 1.149-.533 1.83 1.484.02 2.833-.155 3.958-1.315ZM14.328 1.25A3.187 3.187 0 0 1 18.71.594c.819.639 1.273 1.562 1.28 2.557a3.201 3.201 0 0 1-.642 1.94l-5.005 6.68a3.767 3.767 0 0 1-1.082 2.29c-1.601 1.647-3.458 1.917-5.224 1.917-.444 0-.882-.017-1.308-.034h-.015c-.258-.01-.514-.02-.767-.026l-2.317-.052 1.628-1.65c.915-.927 1.032-1.584 1.18-2.415v-.008c.156-.867.348-1.946 1.506-3.133a3.865 3.865 0 0 1 1.542-.916l4.842-6.493ZM3 17.998h14v-7h2v9H3c-1.654 0-3-1.346-3-3v-14h9v2H2v12c0 .551.448 1 1 1Z';
var IconTheme = baseIcon('IconTheme', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconThemePath
});
export default IconTheme;
//# sourceMappingURL=index.js.map